import React from 'react';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Bucket } from '../../services/executionStatsService';
import EntityDetailDrawer from '../EntityDetailDrawer';
import RunList, { RunListQuery } from './RunList';
import { BUCKET_LABELS } from './executionStatsVocabulary';

interface RunListDrawerProps {
    open: boolean;
    onClose: () => void;
    /** The flow, node or campaign name, for the heading. */
    title: string;
    query: RunListQuery | null;
    onBucketChange: (bucket: Bucket | null) => void;
    buckets?: Bucket[];
}

/**
 * The runs behind a count on a dashboard.
 *
 * Docked rather than overlaid, like CaseTimelineDrawer, so the chart or table
 * the reader clicked stays on screen while they work through the runs.
 */
const RunListDrawer: React.FC<RunListDrawerProps> = ({ open, onClose, title, query, onBucketChange, buckets }) => (
    <EntityDetailDrawer
        open={open}
        onClose={onClose}
        docked
        dockedMinWidth={1280}
        icon={<ListAltIcon />}
        subtitle={query?.bucket ? `${BUCKET_LABELS[query.bucket]} runs` : 'Runs'}
        title={title}
        description={
            query
                ? `Between ${new Date(query.from).toLocaleString()} and ${new Date(query.to).toLocaleString()}.`
                : ''
        }
    >
        {query && <RunList query={query} buckets={buckets} onBucketChange={onBucketChange} />}
    </EntityDetailDrawer>
);

export default RunListDrawer;
